import { useState } from "react";
import { X, Shield } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const DISMISS_KEY = "encore_banner_dismissed";

const EarlyAdopterBanner = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(DISMISS_KEY) === "true"
  );

  if (dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "true");
    setDismissed(true);
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: "auto", opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="relative z-50 overflow-hidden"
      >
        <div className="border-b border-white/5">
          <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center justify-center gap-2 text-[11px] sm:text-xs">
            <Shield className="w-3.5 h-3.5 shrink-0 text-primary" />
            <span className="font-medium text-center text-foreground/80">
              {user
                ? "You're an early adopter! Trendsetter badge earned 🏆"
                : "Be the first — earn an exclusive badge & help shape the app"}
            </span>
            {!user && (
              <button
                onClick={() => navigate("/auth")}
                className="ml-2 shrink-0 font-bold underline underline-offset-2 hover:opacity-80 transition-opacity"
              >
                Join now
              </button>
            )}
            <button
              onClick={handleDismiss}
              className="ml-2 shrink-0 hover:opacity-70 transition-opacity"
              aria-label="Dismiss banner"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default EarlyAdopterBanner;
